import { yupResolver } from "@hookform/resolvers/yup";
import { motion } from "framer-motion";
import React, { useEffect, useRef, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { PiArchiveBoxFill, PiGearFill, PiPaintBrushFill } from "react-icons/pi";
import * as yup from "yup";
import BasicInput from "../../../../components/inputs/BasicInput/BasicInput";
import config from "../../../../config/config";
import useFetch from "../../../../services/useFetch";
import ScanProduct from "../../scanComponents/ScanProduct";
import ScanResponsable from "../../scanComponents/ScanResponsable";
import ScanEmplacement from "../../scanComponents/scanEmplacement";
import BoutonAtelierMenu from "../AtelierMenu/BoutonAtelierMenu/BoutonAtelierMenu";

const schema = yup
  .object({
    // code_barre: yup.string()
    // .matches(/^[0-9]{8}[0-9]{2}[0-9]{2}[0-9]{2}[0-9]{2}[1234]{1}[0-9A-Z]{3}$/, 'Le code-barre ne correspond pas aux critères requis')
    // .length(20, 'Le code-barre doit contenir exactement 20 caractères')
    // .required('Le code-barre est requis'),
  })
  .required();

const AtelierWait = ({ handleError, handleSuccess }) => {
  const apiUrlScanAtelier = config.apiUrl + "/scan-atelier/";
  const apiUrlProductAttente = config.apiUrl + "/product-set-to-wait/";
  const inputRef = useRef(null);
  const [waitChoice, setWaitChoice] = useState(null);
  const [scannedOperateur, setScannedOperateur] = useState(null);
  const [scannedEmplacement, setScannedEmplacement] = useState(null);
  const [scannedProduct, setScannedProduct] = useState(null);

  const {
    register,
    formState: { isValid },
    handleSubmit,
    setFocus,
    control,
  } = useForm({
    resolver: yupResolver(schema),
  });

  console.log(waitChoice);

  const waitMenu = [
    {
      label: "Attente esthétique",
      text: "Attente scan produit à mettre en attente esthétique",
      function: (choiceObject) => setWaitChoice(choiceObject),
      icon: <PiPaintBrushFill size={"25%"} />,
      value: "attente_esthetique",
    },
    {
      label: "Attente matière",
      text: "Attente scan produit à mettre en attente matière",
      function: (choiceObject) => setWaitChoice(choiceObject),
      icon: <PiArchiveBoxFill size={"25%"} />,
      value: "attente_matiere",
    },
    {
      label: "Attente fonctionnement",
      text: "Attente scan produit à mettre en attente fonctionnement",
      function: (choiceObject) => setWaitChoice(choiceObject),
      icon: <PiGearFill size={"25%"} />,
      value: "attente_fonctionnement",
    },
  ];

  const { data, triggerFetch: triggerFetchScanAtelier } = useFetch(
    apiUrlScanAtelier,
    "GET",
    []
  );

  const { triggerFetch: triggerFetchProductRebut } = useFetch(
    apiUrlProductAttente,
    "POST",
    []
  );

  const handleKeyDown = (event) => {
    if (event && event.key === "Enter") {
      event.preventDefault();
      handleSubmit(handleFormSubmit)();
    }
  };

  const handleFormSubmit = (data) => {
    if (isValid) {
      triggerFetchScanAtelier(
        apiUrlScanAtelier + data.code,
        {
          method: "GET",
        },
        false,
        handleError
      );
      inputRef.current.value = "";
    }
  };

  useEffect(() => {
    switch (data?.type) {
      case "operateur":
        setScannedOperateur(data);
        break;
      case "poste":
        setScannedEmplacement(data);
        break;
      case "stockage":
        setScannedEmplacement(data);
        break;
      case "cadre":
        setScannedProduct(data);
        break;
      default:
        break;
    }
  }, [data]);

  useEffect(() => {
    if (scannedEmplacement && scannedProduct && scannedOperateur) {
      const data = {
        operateur: scannedOperateur.code,
        cadre: scannedProduct.code,
        emplacement: scannedEmplacement.code,
        wait: waitChoice.value,
      };

      triggerFetchProductRebut(
        apiUrlProductAttente,
        {
          method: "POST",
          body: JSON.stringify(data),
        },
        handleSuccess,
        handleError
      );
    }
  }, [scannedEmplacement, scannedProduct, scannedOperateur]);

  useEffect(() => {
    if (inputRef && inputRef.current) {
      inputRef.current.focus();
    }
  }, [inputRef]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (inputRef.current && !inputRef.current.contains(event.target)) {
        // Clic à l'extérieur du champ, rétablir le focus
        inputRef.current.focus();
      }
    };

    // Ajouter un écouteur d'événements pour gérer les clics à l'extérieur
    document.addEventListener("click", handleClickOutside);

    return () => {
      // Nettoyer l'écouteur d'événements lors du démontage du composant
      document.removeEventListener("click", handleClickOutside);
    };
  }, [inputRef]);

  return waitChoice ? (
    <>
      <Form noValidate>
        <BasicInput
          inputRef={inputRef}
          labelText="code"
          controlId="code"
          control={control}
          name="code"
          setFocus={setFocus}
          placeholder="code"
          registerFunction={register}
          onKeyDown={handleKeyDown}
          hidden
        />
      </Form>
      <Row className="h-100">
        <motion.div
          key={1}
          className="col-4 h-100"
          initial={{ x: 200, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ delay: 0 }}
        >
          <ScanResponsable
            operateur={scannedOperateur}
            className="bg-aluminium text-black scan-border-warning"
          />
        </motion.div>
        <motion.div
          key={2}
          className="col-4 h-100"
          initial={{ x: 200, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ delay: 0.1 }}
        >
          <ScanEmplacement
            emplacement={scannedEmplacement}
            className="bg-aluminium text-black scan-border-warning"
          />
        </motion.div>
        <motion.div
          key={3}
          className="col-4 h-100"
          initial={{ x: 200, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ delay: 0.2 }}
        >
          <ScanProduct
            product={scannedProduct}
            className="bg-aluminium text-black scan-border-warning"
            message={waitChoice.text}
          />
        </motion.div>
      </Row>
    </>
  ) : (
    <Row className="h-100">
      <motion.div
        key={1}
        className="col-12 h-100"
        initial={{ x: 200, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ delay: 0 }}
      >
        <div className="d-flex flex-column h-100 justify-content-center align-items-center">
          <h1 className="text-uppercase mb-5">
            Choisissez la raison de la mise en attente
          </h1>
          <Row className="w-100">
            {waitMenu.map((item, index) => (
              <Col key={index} md={4} className="d-flex justify-content-center">
                <BoutonAtelierMenu
                  key={index}
                  onClick={() => item.function(item)}
                  icon={item.icon}
                >
                  {item.label}
                </BoutonAtelierMenu>
              </Col>
            ))}
          </Row>
        </div>
      </motion.div>
    </Row>
  );
};

export default AtelierWait;
